import IconSeguranca from '@mobi/ds/static/icons/outlined/seguranca.svg'

import './qr-code-flux.scss'

const QrCodeFlux = ({ qrCode }) => {
  return (
    <div className="final_screen__content qrcode">
      <h1 className="final_screen__title">
        {`Antecipe seu Saque-`}
        <br />
        {`Aniversário FGTS pelo app`}
      </h1>
      <p className="final_screen__text">
        Abra a câmera e aponte o seu celular para o QR <br /> Code e finalize a
        sua contratação no app Itaú
      </p>

      <div className="qrcode__img-wrapper">
        <img
          src={`data:image/jpeg;base64,${qrCode}`}
          alt="qrcode para abrir aplicativo"
          className="qrcode__img"
        />
      </div>

      <div className="qrcode__additional-data">
        <IconSeguranca variant="secondary" />
        <p className="qrcode__additional-data-text">
          Essa etapa vai ser feita pelo seu celular por motivos de segurança dos
          seus dados
        </p>
      </div>
    </div>
  )
}

export default QrCodeFlux
